<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-13 14:59:29
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 18:52:28
 -->
<template>
<div class="closeBox">
  <van-popup :value="show" @click-overlay="emitClose" class="noBg">
    <div class="closeConBox">
      <div class="title">提示</div>
      <div class="msg" :class="type == 'close'?'center':''">{{msg}}</div>
      <div class="btns">
        <van-button round class="btn close" type="primary" @click="close">直接退出</van-button>
        <van-button round class="btn next" type="primary" @click="next">下一个模块</van-button>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
import {
  getArgs
} from '@/assets/js/common'
export default {
  name: 'OralExpressionClose',
  props: {
    type: {
      type: String,
      default: 'close'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    type(val) {
      if (val == 'close') {
        this.msg = '您确定要离开当前学习吗？'
      } else {
        this.msg = '太棒了！恭喜您完成该模块的学习，再接再厉哦！'
      }
    }
  },
  mounted() {
    const param = getArgs()
    this.business_id = param.business_id || 100002
    if (this.type == 'close') {
      this.msg = '您确定要离开当前学习吗？'
    } else {
      this.msg = '太棒了！恭喜您完成该模块的学习，再接再厉哦！'
    }
  },
  data() {
    return {
      msg: '',
      business_id: null
    }
  },
  methods: {
    emitClose() {
      this.$emit('close')
    },
    next() {
      this.$emit('nextClick')
    },
    close() {
      const book_id = getArgs().book_id
      // jumpWebView.getReturn()
      location.replace('./index.html?showDetail=true&book_id=' + book_id + `&business_id=${this.business_id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.closeBox {
  .noBg {
    background: transparent;

    .closeConBox {
      background: #fff;
      border-radius: 5px;
      padding: 20px;
      box-sizing: border-box;
      width: 294px;

      .title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: rgba(69, 70, 74, 1);
        line-height: 16px;
        margin-bottom: 20px;
      }

      .msg {
        font-size: 14px;
        font-weight: 400;
        color: rgba(116, 118, 125, 1);
        line-height: 21px;
        margin-bottom: 22px;

        &.center {
          text-align: center;
        }
      }

      .btns {
        display: flex;
        justify-content: space-between;

        .btn {
          width: 120px;
          height: 40px;
          line-height: 38px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(151, 151, 151, 1);
          color: #74767d;
          font-size: 16px;

          &.next {
            background: #45d585;
            border-color: #45d585;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
